import React from "react";
import { useTranslation } from "react-i18next";
import { Hero } from "../components/Hero";
import { MobilityShift } from "../components/MobilityShift";
import { WhoIsItFor } from "../components/WhoIsItFor";
import { MobilityCycleSelector } from "../components/MobilityCycleSelector";
import { ProductPillars } from "../components/ProductPillars";
import { PlanCard } from "../components/PlanCard";
import { Reveal, Overline } from "../components/Reveal";
import { CTAButton } from "../components/CTAButton";
import { CTASection } from "../components/Sections";
import { PLANS } from "../data/plans";

export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <Hero />
      <MobilityShift />
      <WhoIsItFor />
      <MobilityCycleSelector />
      <ProductPillars />

      <section className="py-24 md:py-32 border-t border-white/5" data-testid="home-plans">
        <div className="container-x">
          <Reveal>
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
              <div>
                <Overline color="gold">{t("homePlans.overline")}</Overline>
                <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">{t("homePlans.title")}</h2>
              </div>
              <CTAButton to="/plans" variant="secondary" testId="home-view-all-plans">{t("common.viewAllPlans")}</CTAButton>
            </div>
          </Reveal>

          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {PLANS.slice(0, 3).map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}><PlanCard plan={p} /></Reveal>
            ))}
          </div>
          <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {PLANS.slice(3).map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}><PlanCard plan={p} /></Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title={t("finalCta.title")}
        subtitle={t("finalCta.subtitle", { pronounced: t("common.pronounced") })}
        ctaLabel={t("common.getQuote")}
        ctaTo="/quote"
        testId="home-final-cta"
      />
    </>
  );
}
